/**
 * @generated SignedSource<<3b90831a3ebbcdb3917801b7e98f4cca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserShortFragment$data = {
  readonly email: string | null | undefined;
  readonly first_name: string | null | undefined;
  readonly id: string;
  readonly last_name: string | null | undefined;
  readonly phone: string | null | undefined;
  readonly " $fragmentType": "UserShortFragment";
};
export type UserShortFragment$key = {
  readonly " $data"?: UserShortFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserShortFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserShortFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "first_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "10041638178992e23259a8f21230c9a5";

export default node;
